(function () {
    'use strict';
    
    angular.module('showcaseApp')
        .config(function($mdAriaProvider) {
            // Globally disables all ARIA warnings.
            $mdAriaProvider.disableWarnings();
        });
})();
